module.exports = __webpack_public_path__ + "img/cooperate_logo_1.3ac753ae.png";